import { updateStore } from "./tools";
const initialState = { isLoading: false };

const restoreState = {
  ...initialState,
};

const common = (state = restoreState, { type, payload = null }) => {
  switch (type) {
    case "SET_COMMON":
      return updateStore(state, payload);
    case "UPDATE_COMMON":
      return updateStore(state, payload);
    case "RESET_COMMON":
      return initialState;
    default:
      return state;
  }
};

export default common;
